import React from 'react';
import { Instagram, ShoppingCart, Mail } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { merchConfig } from '../data/mock';

const Header = ({ onCartClick }) => {
  const { cartCount } = useCart();

  return (
    <header className="site-header">
      <div className="header-content">
        <div className="header-left">
          <img 
            src="https://customer-assets.emergentagent.com/job_gored-merch-drop/artifacts/2v69vx4n_rendered%20red%20GORED.png" 
            alt="GORED Logo" 
            className="header-logo"
          />
          <div className="header-info-group">
            <a 
              href="https://www.instagram.com/gored.band?igsh=MXQ1dXhxdzhpcmk0dg==" 
              target="_blank"
              rel="noopener noreferrer"
              className="header-instagram"
            >
              <Instagram size={18} />
              <span>Follow Us On Instagram: gored.band</span>
            </a>
            <a 
              href={`mailto:${merchConfig.contactEmail}`}
              className="header-email"
            >
              <Mail size={18} />
              <span>{merchConfig.contactEmail}</span>
            </a>
          </div>
          <div className="preorder-only-badge">
            NOW AVAILABLE
          </div>
        </div>
        <nav className="header-nav">
          <a href="#home" className="nav-link active">HOME</a>
          <a href="#shop" className="nav-link">SHOP</a>
          <button onClick={onCartClick} className="cart-button">
            <ShoppingCart size={20} className="cart-icon-desktop" />
            <ShoppingCart size={28} className="cart-icon-mobile" />
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
